import AdswizzDeviceTypeLabel from '@/Enums/Adswizz/DeviceTypeLabel.enum';
import BeeswaxMappedDigitalChannel from '@/Enums/Beeswax/BeeswaxMappedDigitalChannel.enum';
import Color from '@/Enums/Color.enum';
import Device from '@/Enums/Device.enum';
import { CTV_DEVICE, GOOGLE_DEVICE_LABELS } from './beeswax';

export const PRIMARY = '#1B4332';
export const GREY = '#84818A';

export const CHART_COLORS = {
  [BeeswaxMappedDigitalChannel.STREAMING]: Color.Primary,
  [BeeswaxMappedDigitalChannel.DISPLAY]: Color.AccentYellow,
  [BeeswaxMappedDigitalChannel.OLV]: Color.LightGreen,
  [BeeswaxMappedDigitalChannel.AUDIO]: Color.Purple,
  [BeeswaxMappedDigitalChannel.GAMING]: Color.AccentRed,
  [BeeswaxMappedDigitalChannel.OLV_APP_BASED]: Color.LightBlue,
  [Device.Mobile]: Color.AccentYellow,
  [Device.Desktop]: Color.LightGreen,
  [Device.GamesConsole]: Color.AccentRed,
  [Device.Tablet]: Color.Purple,
  [CTV_DEVICE]: Color.Primary,

  [GOOGLE_DEVICE_LABELS.VIDEO_LABEL]: Color.Primary,

  [AdswizzDeviceTypeLabel.Phone]: Color.Primary,
  [AdswizzDeviceTypeLabel.SmartSpeaker]: Color.AccentYellow,
  // [AdswizzDeviceTypeLabel.Tablet] === [Device.Tablet] === PURPLE,
  // [AdswizzDeviceTypeLabel.Desktop] === [Device.Desktop] === LIGHT_GREEN,
  [AdswizzDeviceTypeLabel.SmartTV]: Color.AccentRed,
  [AdswizzDeviceTypeLabel.Other]: Color.LightBlue,
  [AdswizzDeviceTypeLabel.SmartWatch]: Color.Indigo700,
  [AdswizzDeviceTypeLabel.PortableMediaPlayer]: Color.RedOrange,
  [AdswizzDeviceTypeLabel.GamingConsole]: Color.DarkBlue,
  [AdswizzDeviceTypeLabel.ConnectedVehicle]: Color.BrightPink,
};

/**In case chart metric does not have an assigned color - use default colors in order */
export const DEFAULT_CHART_COLORS: Color[] = [
  Color.Primary,
  Color.AccentYellow,
  Color.LightGreen,
  Color.Purple,
  Color.AccentRed,
  Color.LightBlue,
  Color.Indigo700,
  Color.RedOrange,
  Color.DarkBlue,
  Color.BrightPink,
];
